import Button from "@components/Button";
import { Form } from "react-router-dom";
import { Plan, StripePrice } from "src/types";

interface Props {
  buttonClassName?: string;
  buttonTitle: string;
  currency: string;
  isSubmitting: boolean;
  plan: Plan;
  priceId: string | undefined;
  price: StripePrice | undefined;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

export default function SubscriptionForm({
  buttonClassName = "",
  buttonTitle,
  currency,
  isSubmitting,
  plan,
  priceId,
  price,
  setIsSubmitting,
}: Props) {
  const handleClick = () => {
    setIsSubmitting(true);
  };

  return (
    <Form onSubmit={handleClick} method="post">
      <input type="hidden" name="currency" value={currency} />

      <input type="hidden" name="plan" value={plan} />

      <input type="hidden" name="priceId" value={priceId} />

      <input type="hidden" name="fullPrice" value={price?.currency_options[currency].unit_amount_decimal ?? price?.unit_amount_decimal} />

      <Button
        className={buttonClassName}
        submitting={isSubmitting}
        title={buttonTitle}
        type="submit"
      />
    </Form>
  );
}
